import { upperCase } from 'lodash';
import type {
  OrderDirectionEnum,
  ProjectOrderEnum,
  ProjectOrderInput,
} from '@frameio/graphql-client/generated';
import type {
  ProjectSortBy,
  ProjectSortByField,
} from '../resources/projects/types';

const mapSoryByFieldToProjectOrderEnum = (
  field: ProjectSortByField
): ProjectOrderEnum => {
  if (field === 'created_at') return 'CREATED_AT';
  if (field === 'status') return 'PROJECT_STATUS';

  return 'NAME';
};

/**
 * Maps the ProjectSortBy object to ProjectOrderInput.
 *
 * @param sortBy - The sorting criteria for the project.
 * @returns An object containing the field and direction for sorting projects.
 */
export const mapSortByToProjectOrderInputs = (
  sortBy: ProjectSortBy
): ProjectOrderInput => {
  return {
    field: mapSoryByFieldToProjectOrderEnum(sortBy.field),
    direction: upperCase(sortBy.order) as OrderDirectionEnum,
  };
};
